<template>
  <div class="questionnaire-dialog">
    <van-popup v-model="visiable" :close-on-click-overlay="false">
      <div class="questionnaire-dialog-content">
        <img src="../../../assets/images/questionnaire/questionnaire-dialog-icon.png" alt="" class="icon">
        <div class="questionnaire-dialog-content-title">
          问卷调查
        </div>
        <div class="questionnaire-dialog-content-multiple" v-if="surveyList.length > 1">
          <div class="questionnaire-dialog-content-text">诚挚邀请各位老师参与问卷调查，对于以下课程提出建议和要求：</div>
          <div class="questionnaire-dialog-content-multiple-list">
            <div class="questionnaire-dialog-content-multiple-item" v-for="(item, index) in surveyList" :key="index"
                 @click="surveyId = item.surveyId">
              <img src="@/assets/images/questionnaire/select.png" alt="" class="select-icon"
                   v-if="surveyId === item.surveyId"/>
              <img src="@/assets/images/questionnaire/no-select.png" alt="" class="select-icon" v-else/>
              <span class="questionnaire-dialog-content-multiple-item-title">{{ item && item.surveyTitle }}</span>
            </div>
          </div>
        </div>
        <div class="questionnaire-dialog-content-text" v-else>
          诚挚邀请各位老师对于<span class="tip">《{{ title }}》</span>提出建议和需求! 期待为大家带来更多优质内容!
        </div>
        <div class="questionnaire-dialog-footer">
          <div class="btn btn1" @click.stop="nextTalk" v-track="{ functionName: '问卷-下次再说'}">下次再说</div>
          <div class="btn btn2" @click.stop="goParticipate" v-track="{ functionName: '问卷-去参加'}">去参加</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Toast} from 'vant'

export default {
  name: 'QuestionnaireDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visiable: false,
      title: '',
      surveyList: [],
      submitId: '',
      surveyId: ''
    }
  },
  watch: {
    value(val) {
      this.visiable = val
    }
  },
  methods: {
    init(surveyList) {
      this.surveyList = surveyList
      if (!this.surveyList.length) return
      if (this.surveyList.length === 1) {
        const {surveyTitle, surveyId, submitId} = this.surveyList[0]
        this.title = surveyTitle
        this.surveyId = surveyId
        this.submitId = submitId
      } else {
        this.title = ''
        this.surveyId = ''
        this.submitId = ''
      }
    },
    nextTalk() {
      sessionStorage.setItem('nextTalk', true)
      this.$emit('input', false)
    },
    goParticipate() {
      if (!this.surveyId) {
        Toast('请选择一个问卷')
        return
      }
      this.$emit('input', false)
      window.sessionStorage.setItem('serviceId', this.surveyId)
      this.$router.push({
        path: 'questionnaire',
        query: {
          submitId: this.submitId,
          surveyId: this.surveyId
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.questionnaire-dialog {
  .questionnaire-dialog-content {
    width: 320px;
    background: url("../../../assets/images/questionnaire/questionnaire-dialog-bg.png") no-repeat center center / 100% 100%;
    border-radius: 20px;
    padding: 93px 26px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .icon {
      position: absolute;
      top: 0;
      width: 148px;
      height: 138px;
      left: 50%;
      transform: translate(-50%, -35%);
    }

    .questionnaire-dialog-content-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 17px;
      color: #000000;
      text-align: center;
      margin-bottom: 10px;
    }

    .questionnaire-dialog-content-multiple {
      display: flex;
      flex-direction: column;
      max-height: 200px;

      .questionnaire-dialog-content-multiple-list {
        flex: 1;
        height: 0;
        overflow-y: auto;
        padding-right: 20px;
        margin-right: -18px;
        .questionnaire-dialog-content-multiple-item {
          display: flex;
          margin-top: 12px;

          .select-icon {
            width: 15px;
            height: 15px;
            margin-right: 10px;
            margin-top: 4px;
          }

          .questionnaire-dialog-content-multiple-item-title {
            flex: 1;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }
    }

    .questionnaire-dialog-content-text {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);

      .tip {
        font-weight: 600;
        color: #000;
      }
    }

    .questionnaire-dialog-footer {
      display: flex;
      align-items: center;
      margin-top: 12px;

      .btn {
        width: 130px;
        height: 42px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .btn1 {
        background: rgba(0, 0, 0, 0.08);
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #7A8494;
      }

      .btn2 {
        background: #EB1700;
        margin-left: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }
}
/deep/ .van-popup {
  background-color: transparent;
  overflow-y: visible;
  z-index: 10006 !important;
}

/deep/ .van-overlay {
  z-index: 10005 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/QuestionnaireDialog.vue